export default "__VITE_ASSET__ba6a767f__"